import { Page, NavParams, ViewController, Events } from 'ionic-angular'
import { Component } from '@angular/core'
import { Http } from '@angular/http'
import { Location } from '../../services/location'
import * as array from '../../utils/array'
import { DOMAIN } from '../../config'

@Component({
  templateUrl: 'build/pages/search/search.html',
  providers: [Location]
})
export class SearchModal {
  private query: String
  private locations: any = Array
  private input: any
  private loading: boolean
  private parent: any
  
  constructor(private http: Http, private events: Events, private controller: ViewController, params: NavParams) {
    this.locations = []
    this.input = params.get('input')
    this.parent = params.get('parent')
  }
  
  dismiss() {
    this.controller.dismiss()
  }

  change(event) {
    this.geocode()
    
    if (this.query.length < 3) {
      this.locations = null
    }
  }

  geocode() {
    this.loading = true
    
    if (!this.query || this.query.length < 3) {
      this.locations = null
      this.loading = false
      return
    }

    this.http
      .get(`//${DOMAIN}/api/autocomplete?query=${this.query}`)
      .map(res => res.json())
      .subscribe(data => {
        if (data.places) {
          let places = array.unique(data.places, 'name')
          this.locations = places
        } else {
          this.locations = null
        }
      }, err => {
        this.locations = null
        console.error(err)
      }, () => {
        console.info('autocomplete finished')
        this.loading = false
      })
  }

  details(item) {
    if (this.parent === 'home') {
      this.events.publish('carpostal:home:selected', item)
    } else {
      this.events.publish('carpostal:search:selected', this.input, item)
    }

    this.controller.dismiss()
  }

  getItems() {
    return this.locations
  }

  ngAfterViewInit() {
    this.query = '' as String
    (<HTMLInputElement>document.querySelector('.searchbar-input')).blur()
    
    setTimeout(() => {
      (<HTMLInputElement>document.querySelectorAll('.searchbar-input')[1]).focus()
    }, 500)
  }
}
